import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Youtube } from "lucide-react";

const LOGO_URL = "/logo.jpg";

const FOOTER_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/campaigns", label: "Our Services" },
  { to: "/campaigns", label: "Get Help" },
  { to: "/register", label: "Get Involved" },
  { to: "/news", label: "News" },
  { to: "/contact", label: "Contact" },
];

const SOCIALS = [
  { Icon: Facebook, href: "#", label: "Facebook" },
  { Icon: Twitter, href: "#", label: "Twitter" },
  { Icon: Instagram, href: "#", label: "Instagram" },
  { Icon: Youtube, href: "#", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer className="relative mt-12">
      {/* Top decorative band — about / credits, subtle */}
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pb-10 pt-4 text-center">
        <p className="italic font-serif-display text-brand-primary text-sm">
          Spes alit, vitam renovat <span className="text-brand-muted not-italic font-sans-ui">— Hope nourishes, life renews.</span>
        </p>
        <p className="mt-3 text-xs text-brand-muted font-sans-ui">
          <a href="mailto:dkarezcommunitys@gmail.com" className="hover:text-brand-primary transition-colors" data-testid="footer-email">
            dkarezcommunitys@gmail.com
          </a>
          <span className="mx-2 text-brand-border">•</span>
          <a href="tel:+447400455570" className="hover:text-brand-primary transition-colors" data-testid="footer-phone">
            +44 7400 455570
          </a>
        </p>
      </div>

      {/* Bottom magenta bar — matches the reference */}
      <div
        className="relative text-white"
        style={{ background: "linear-gradient(120deg, #A02157 0%, #E91E63 100%)" }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo monogram + nav */}
          <div className="flex flex-wrap items-center gap-6">
            <Link to="/" className="flex items-center" data-testid="footer-logo">
              <img
                src={LOGO_URL}
                alt="Dkarez"
                className="w-12 h-12 rounded-full border-2 border-white/40 object-cover"
              />
            </Link>
            <nav className="flex flex-wrap items-center gap-x-7 gap-y-2 text-sm">
              {FOOTER_LINKS.map((l, i) => (
                <Link
                  key={`${l.to}-${i}`}
                  to={l.to}
                  className="text-white/85 hover:text-white font-medium transition-colors"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Social icons */}
          <div className="flex items-center gap-2.5">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                className="w-10 h-10 rounded-full bg-white/15 hover:bg-white/30 flex items-center justify-center transition-colors backdrop-blur-sm"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
              >
                <s.Icon size={16} strokeWidth={2} className="text-white" />
              </a>
            ))}
          </div>
        </div>
        <div className="border-t border-white/20">
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-3 text-xs text-white/80 text-center">
            © {new Date().getFullYear()} Dkarez Community Support CIC. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
